import { createContext, useContext, useState, useCallback } from "react";
import AlertModal from "../components/_shared/Modals/AlertModal";

const AlertContext = createContext();

export const useAlert = () => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error("useAlert must be used within AlertProvider");
  }
  return context;
};

export const AlertProvider = ({ children }) => {
  const [alertState, setAlertState] = useState({
    isOpen: false,
    type: "alert", // 'alert', 'confirm', 'prompt'
    title: "",
    message: "",
    defaultValue: "",
    resolve: null,
  });

  const alert = useCallback((message, title = "Melding") => {
    return new Promise((resolve) => {
      setAlertState({
        isOpen: true,
        type: "alert",
        title,
        message,
        defaultValue: "",
        resolve,
      });
    });
  }, []);

  const confirm = useCallback((message, title = "Stadfest") => {
    return new Promise((resolve) => {
      setAlertState({
        isOpen: true,
        type: "confirm",
        title,
        message,
        defaultValue: "",
        resolve,
      });
    });
  }, []);

  const prompt = useCallback((message, title = "Skriv inn", defaultValue = "") => {
    return new Promise((resolve) => {
      setAlertState({
        isOpen: true,
        type: "prompt",
        title,
        message,
        defaultValue,
        resolve,
      });
    });
  }, []);

  const handleClose = useCallback((value) => {
    if (alertState.resolve) {
      alertState.resolve(value);
    }
    setAlertState({
      isOpen: false,
      type: "alert",
      title: "",
      message: "",
      defaultValue: "",
      resolve: null,
    });
  }, [alertState]);

  return (
    <AlertContext.Provider value={{ alert, confirm, prompt }}>
      {children}
      <AlertModal
        isOpen={alertState.isOpen}
        type={alertState.type}
        title={alertState.title}
        message={alertState.message}
        defaultValue={alertState.defaultValue}
        onClose={handleClose}
      />
    </AlertContext.Provider>
  );
};
